module.exports = __webpack_public_path__ + "img/tesar.35eb84d2.jpg";